// extracted by mini-css-extract-plugin
export default {"container":"QuizAttemptLayout_container__0nY13"};